import * as brandText from './list/brand-text'
import * as countryCode from './list/country-code'
import * as currency from './list/currency'
import * as dateTime from './list/date-time'
import * as deliveryMapColorConfig from './list/delivery-map-color-config'

const ENUM_CONFIG_TYPE = {
  COUNTRY: 1,
  CURRENCY: 2,
  LANGUAGE: 3,
}

function configMixin(targetConfig = {}, type = ENUM_CONFIG_TYPE.COUNTRY) {
  let defaultCountry
  switch (type) {
    case ENUM_CONFIG_TYPE.COUNTRY:
      defaultCountry = 'MX'
      break

    case ENUM_CONFIG_TYPE.CURRENCY:
      defaultCountry = 'MXN'
      break

    case ENUM_CONFIG_TYPE.LANGUAGE:
      defaultCountry = 'es-MX'
      break
  }

  const finalConfig = {}
  Object.keys(targetConfig).map(key => {
    finalConfig[key] = targetCountry => {
      return targetConfig[key][targetCountry] || targetConfig[key][defaultCountry]
    }
  })
  return finalConfig
}

export default {
  brandText: configMixin(brandText),
  countryCode: configMixin(countryCode),
  deliveryMapColorConfig: configMixin(deliveryMapColorConfig),
  currency: configMixin(currency, ENUM_CONFIG_TYPE.CURRENCY),
  dateTime: configMixin(dateTime, ENUM_CONFIG_TYPE.LANGUAGE),
}
export { currency } from './list/currency'
